// src/config/logger.ts
import { logger } from '@myorg/type-lib';

export function initializeLogger() {
  logger.init(import.meta.env.VITE_DEBUG);
  logger.log("Env:", import.meta.env.VITE_ENV);
}

export { logger };
